import { API_ROOT } from '../../config/config'

import { doGet, doPost, doPut, doDownload, doDelete } from './utils'

// const API_ROOT = 'http://localhost:9005/api'

export const getEndOfProjectForm = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate`
  return doGet(url)
}

export const updateEndOfProject = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate`
  return doPost(url, request)
}

export const getTerminateProjectFileCoworker = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/attachments`
  return doGet(url)
}

//coworker
export const saveTerminateProjectFileCoworker = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/attachments`
  return doPost(url, request)
}

export const updateTerminateProjectFileNameCoworker = (projectVersionId, fileId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/attachments/${fileId}`
  return doPut(url, request)
}

export const deleteTerminateProjectFileCoworker = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/attachments/${fileId}`
  return doDelete(url)
}

export const downloadTerminateProjectFileCoworker = (projectVersionId, path) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/attachments/download?path=${path}`
  return doDownload(url)
}

//staff
export const updateTerminateProjectStaffForm = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/request-for-approve`
  return doPost(url, request)
}

export const getTerminateProjectFileStaff = (projectVersionId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/request-for-approve/attachments`
  return doGet(url)
}

export const saveTerminateProjectFileStaff = (projectVersionId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/request-for-approve/attachments`
  return doPost(url, request)
}

export const updateTerminateProjectFileNameStaff = (projectVersionId, fileId, request) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/request-for-approve/attachments/${fileId}`
  return doPut(url, request)
}

export const deleteTerminateProjectFileStaff = (projectVersionId, fileId) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/request-for-approve/attachments/${fileId}`
  return doDelete(url)
}

export const downloadTerminateProjectFileStaff = (projectVersionId, path) => {
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/request-for-approve/attachments/download?path=${path}`
  return doDownload(url)
}

//director approve
// export const directorApproveTerminateProject = (projectVersionId, request) => {
//   const url = `${API_ROOT}/progress/${projectVersionId}/terminate/approve`
//   return doPost(url, request)
// }

export const directorSecureApproveTerminateProject = (projectVersionId, request) => {
  // /api/progress/{projectVersionId}/terminate/secure-approve
  const url = `${API_ROOT}/progress/${projectVersionId}/terminate/secure-approve`
  return doPost(url, request)
}
